var _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 173.983,
    height: 52.152,
    viewBox: "0 0 46.033 13.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.468 1.036C23.438 2.108 178.403.5 178.403.5l1.072 131.907H15.931Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".99999899px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h596v192H0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 1
    },
    clipPath: "url(#a)",
    transform: "translate(-7.013 -8.306) scale(.31083)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "matrix(.35972 0 0 -.35972 -6.759 81.606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.647 131.645c-2.837 0-5.312 1.611-6.544 4.074h-.834V53.496c0-4.046 3.281-7.343 7.365-7.343 4.054 0 7.342 3.297 7.342 7.343v82.223h-.827c-1.224-2.463-3.671-4.074-6.502-4.074",
    style: {
      fill: "#2d9edf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.778 113.481c-2.832 0-5.277 1.587-6.504 4.062h-.836V53.496c0-4.046 3.288-7.343 7.34-7.343 4.043 0 7.334 3.297 7.334 7.343v64.047h-.824c-1.228-2.475-3.685-4.062-6.51-4.062M168.425 128.244c0 4.069 3.301 7.356 7.363 7.356a7.351 7.351 0 0 0 7.359-7.356 7.354 7.354 0 0 0-7.359-7.353c-4.062 0-7.363 3.293-7.363 7.353M88.841 46.153c-4.041 0-7.332 3.281-7.332 7.343v56.717c0 4.043 3.291 7.33 7.332 7.33 4.066 0 7.355-3.287 7.355-7.33v-64.06h-7.355M100.157 46.153v64.06c0 4.043 3.289 7.33 7.336 7.33 4.063 0 7.342-3.287 7.342-7.33v-64.06h.018c-3.481 0-4.282 4.023-4.282 7.952h.01c0-4.042-3.281-7.952-7.344-7.952h-3.068M151.009 117.547c4.035 0 7.336-3.291 7.336-7.348V53.484c0-4.046-3.301-7.331-7.336-7.331-4.063 0-7.352 3.285-7.352 7.331v64.063h7.352M139.681 117.547h.013V53.484a7.334 7.334 0 0 0-7.338-7.331c-4.05 0-7.349 3.285-7.349 7.331v64.063h-.006c3.469-.004 4.277-4.035 4.277-7.973h-.015c0 4.055 3.297 7.973 7.353 7.973h3.065",
    style: {
      fill: "#ee2722",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.46 46.153a7.342 7.342 0 0 0-7.342 7.343v56.717c0 4.043 3.289 7.334 7.342 7.334 4.053 0 7.346-3.291 7.346-7.334v-64.06h-7.346M264.79 46.153h-.016v64.06a7.339 7.339 0 0 0 7.344 7.334c4.047 0 7.338-3.291 7.338-7.334v-64.06h.01c-3.465 0-4.278 4.035-4.278 7.966h.008c0-4.051-3.289-7.966-7.345-7.966h-3.061M194.888 53.5a7.357 7.357 0 0 0 7.363 7.369 7.362 7.362 0 0 0 7.361-7.369c0-4.05-3.299-7.347-7.361-7.347-4.072 0-7.363 3.297-7.363 7.347",
    style: {
      fill: "#2d9edf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.97 29.164h3.383v123.408h-3.383z",
    style: {
      fill: "#565354",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.728 46.017h41.375v6.844h-41.375z",
    style: {
      fill: "#ee2722",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.765 46.017h38.362v6.844h-38.362z",
    style: {
      fill: "#2d9edf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.103 46.017h25.662v6.844h-25.662z",
    style: {
      fill: "#4c2587",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.765 126.132c0 7.166-3.969 9.587-8.519 9.587-1.844 0-3.487-.387-4.94-1.258-1.452-.777-2.617-1.937-3.491-3.391 0 0-.007.177-.007.267a4.353 4.353 0 1 1-8.705 0V69.771a4.557 4.557 0 0 1 4.554-4.557 4.558 4.558 0 0 1 4.556 4.557c0 .022-.007.042-.007.064v53.779c0 3.777 1.743 5.132 3.969 5.132 2.81 0 3.488-1.84 3.488-4.357V69.648h.013a4.523 4.523 0 0 1 4.518-4.434 4.521 4.521 0 0 1 4.516 4.434h.055v56.484M489.143 135.719h-22.551a4.07 4.07 0 0 1-4.066-4.068 4.07 4.07 0 0 1 4.066-4.066h6.558V70.09h.006c0-.011-.006-.02-.006-.031a4.844 4.844 0 1 1 9.686 0c0 .011-.005.02-.005.031h.005v57.495h6.307a4.065 4.065 0 0 1 4.063 4.066 4.066 4.066 0 0 1-4.063 4.068M407.178 103.83c-8.837 9.221-9.797 12.104-9.797 16.81 0 5.378 1.824 7.589 5.764 7.589 3.744 0 5.377-2.309 5.377-6.246v-5.474a4.514 4.514 0 1 1 9.03 0v6.531c0 4.899-1.154 7.301-2.786 8.836-2.306 2.114-6.051 3.843-11.237 3.843-10.47 0-15.756-4.898-15.756-16.234 0-9.413 5.093-14.982 11.241-21.13 9.99-9.895 10.277-11.815 10.277-17.676 0-4.513-1.25-7.97-6.341-7.97-3.841 0-5.569 2.88-5.569 7.49v5.668a4.804 4.804 0 0 1-9.608 0v-8.26c0-8.646 6.053-12.393 14.889-12.393 11.432 0 15.657 6.246 15.657 17.099 0 8.356-1.728 11.719-11.141 21.517",
    style: {
      fill: "#565354",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnt);
export default __webpack_public_path__ + "static/media/snt.522f41c860b241814907ceb9d5d48322.svg";
export { ForwardRef as ReactComponent };